import React, { useEffect } from 'react';
import LeadForm from '../components/LeadForm';
import { AboutHero } from '../components/AboutHero';
import { ResearchFacilities } from '../components/ResearchFacilities';
import { Partnerships } from '../components/Partnerships';
import { ToyotaMedia } from '../components/ToyotaMedia';

export const About = ({section}) => {
  
  useEffect(()=> {
    const current = document.getElementById(section);
    if (current) window.scrollTo(0, current.offsetTop - 30)
  }, [section])

  useEffect(()=> {
    const gaGroup = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
    // Get active language, fire manual page view.
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Toyota IP Solutions - About Us Page',
        page_location: window.location.href,
        page_path: window.location.pathname,
        send_to: gaGroup
    })
    }
  }, [])
  
  return (
    <div>
      <AboutHero />
      <ResearchFacilities />
      <Partnerships />
      <ToyotaMedia />
      <LeadForm />
    </div>
  )
}